<div class="modal fade" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    Exportar Listagem de Pedidos para Excel
                </h4>        
            </div>
            <div class="modal-body">
                <form #form="ngForm" novalidate>
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-info">
                                <!-- <i class="fas fa-info" aria-hidden="true"></i> A exportação irá considerar os mesmos filtros e ordenação aplicados na pesquisa atual dos pedidos. -->
                                <i class="fas fa-info" aria-hidden="true"></i> A exportação irá considerar os mesmos filtros aplicados atualmente.
                            </div>
                        </div>
                    </div> 
                    
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="nomeExportacao" class="col-form-label">Nome da Exportação</label>
                            <input type="text" class="form-control" [(ngModel)]="nomeExportacao" name="nomeExportacao" id="nomeExportacao" 
                                #nomeExportacaoModel="ngModel" required="required">
                            <p class="form-text text-muted" style="margin-top:0px;">Será o nome do arquivo Excel exportado.</p>                                                                             
                            <sgt-form-control-error
                                *ngIf="nomeExportacaoModel.errors && nomeExportacaoModel.errors.required && nomeExportacaoModel.dirty"
                                msgError="O nome da exportação é obrigatório">
                            </sgt-form-control-error>
                        </div>
                    </div>    
                    
                    <!-- Options -->
                    <div class="card card-options" *ngIf="options">
                        <div class="card-header">
                            <h6 class="card-title mb-0">Campos Opcionais</h6>
                            <small class="card-subtitle mb-0">Selecione os campos opcionais que também deseja exportar</small>                            
                        </div>
                        <ul class="list-group list-group-flush">
                            <li class="list-group-item" *ngIf="isRafitecOuPropex()">
                                Valor do IPI
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportValorIpi" name="exportValorIpi" id="exportValorIpi">
                                    <label class="custom-control-label" for="exportValorIpi"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="isRafitecOuPropex()">
                                Status da Amostra
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportStatusAmostra" name="exportStatusAmostra" id="exportStatusAmostra">
                                    <label class="custom-control-label" for="exportStatusAmostra"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="!isRepresentante">
                                E-commerce
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportEcommerce" name="exportEcommerce" id="exportEcommerce">
                                    <label class="custom-control-label" for="exportEcommerce"></label>
                                </div>                                
                            </li>                            
                            <li class="list-group-item">
                                Cidade e UF do Cliente
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportCidadeUfPessoa" name="exportCidadeUfPessoa" id="exportCidadeUfPessoa">
                                    <label class="custom-control-label" for="exportCidadeUfPessoa"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="configPedido?.exibirLocalDeposito">
                                Local de Depósito
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportLocalDeposito" name="exportLocalDeposito" id="exportLocalDeposito">
                                    <label class="custom-control-label" for="exportLocalDeposito"></label>
                                </div>                                
                            </li>  
                            <li class="list-group-item" *ngIf="!isRafitecOuPropex()">
                                Condição de Pagamento
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportCondicaoPagamento" name="exportCondicaoPagamento" id="exportCondicaoPagamento">
                                    <label class="custom-control-label" for="exportCondicaoPagamento"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="isRafitecOuPropex()">
                                Condição de Pagamento <!-- Tipo de Pagamento -->
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportTipoPrazosPagamento" name="exportTipoPrazosPagamento" id="exportTipoPrazosPagamento">
                                    <label class="custom-control-label" for="exportTipoPrazosPagamento"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item">
                                Prazo Médio
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportPrazoMedio" name="exportPrazoMedio" id="exportPrazoMedio">
                                    <label class="custom-control-label" for="exportPrazoMedio"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="!isRafitecOuPropex()">
                                Desconto Médio
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportPercDescontoMedio" name="exportPercDescontoMedio" id="exportPercDescontoMedio">
                                    <label class="custom-control-label" for="exportPercDescontoMedio"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="configPedido?.exibirFrete">
                                Frete
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportFrete" name="exportFrete" id="exportFrete">
                                    <label class="custom-control-label" for="exportFrete"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="isRafitecOuPropex()">
                                Paletização?
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportPaletizacao" name="exportPaletizacao" id="exportPaletizacao">
                                    <label class="custom-control-label" for="exportPaletizacao"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="isRafitecOuPropex()">
                                Preço Fixo Até
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportPrecoFixoAte" name="exportPrecoFixoAte" id="exportPrecoFixoAte">
                                    <label class="custom-control-label" for="exportPrecoFixoAte"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item" *ngIf="isRafitecOuPropex()">
                                Aplica-se Cláusula de Reajuste?
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportAplicaClausulaReajuste" name="exportAplicaClausulaReajuste" id="exportAplicaClausulaReajuste">
                                    <label class="custom-control-label" for="exportAplicaClausulaReajuste"></label>
                                </div>                                
                            </li>
                            <li class="list-group-item">
                                Motivo Reprovação
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportMotivoReprovado" name="exportMotivoReprovado" id="exportMotivoReprovado">
                                    <label class="custom-control-label" for="exportMotivoReprovado"></label>
                                </div>                                
                            </li> 
                            <li class="list-group-item">
                                Campanha
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportCampanha" name="exportCampanha" id="exportCampanha">
                                    <label class="custom-control-label" for="exportCampanha"></label>
                                </div>                                
                            </li>                             
                            <li class="list-group-item" *ngIf="isAdministrador">
                                Liberação da Bonificação
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportLiberacaoBonificacao" name="exportLiberacaoBonificacao" id="exportLiberacaoBonificacao">
                                    <label class="custom-control-label" for="exportLiberacaoBonificacao"></label>
                                </div>                                
                            </li>                             
                            <li class="list-group-item" *ngIf="isAdministrador || isAtendente || isExpedicao">
                                Expedição
                                <div class="custom-control custom-switch float-right">
                                    <input type="checkbox" class="custom-control-input" [(ngModel)]="options.exportExpedicao" name="exportExpedicao" id="exportExpedicao">
                                    <label class="custom-control-label" for="exportExpedicao"></label>
                                </div>                                
                            </li>                                                                                    
                        </ul>
                    </div>                    
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="export()" id="btnExportPedidoListagem">
                    <i class="far fa-file-excel"></i> Exportar
                </button>              
                <button type="button" class="btn btn-light" (click)="close()">
                    Cancelar
                </button>
            </div>            
        </div>
    </div>
</div>